import { z } from 'zod';
import { payableDataSchema } from '../../Payable.js';
import { inspectionServiceConfigSchema } from '../configurations/InspectionServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderInspectionDataSchema = servicesProviderGenericDataSchema
    .merge(payableDataSchema)
    .extend({
    config: z.object({
        [Services.INSPECTION]: inspectionServiceConfigSchema,
    }),
});

export { servicesProviderInspectionDataSchema };
//# sourceMappingURL=ServicesProviderInspectionData.js.map
